<div class="queue-view-tab-outer-container" [ngClass]="{'preview-open': selectedPreviewItem}">
  <div class="queue-view-tab-inner-container">
    <app-info-label *ngIf='isHybrid | async'>{{ 'queueView.monitorViewNotIncludeCX' | translate }}</app-info-label>
    <div class="grid-options">
      <div class="grid-options-left">
        <div class="dropdowns">
          <div class="dropdown-container" [hidden]="workItemTypeList && workItemTypeList.length < 2">
            <label class="filter-label">{{ 'queueViewTab.labels.channelLabel' | translate }}</label>
            <app-dropdown [dropdownId]="'workitem-type'" [items]="workItemTypeList" (selectedItemChange)="onWorkItemTypeChange($event)"></app-dropdown>
          </div>

          <div class="dropdown-container" *ngIf="gridSetting.hasFolderSelector">
            <label class="filter-label">{{ getLabelByWorkItemType('folderLabel') | translate }}</label>
            <app-hierarchy-dropdown *ngIf="folderList" [items]="folderList" [value]="selectedFolderId" [iconNameForDropdown]="'folder-empty'"
                                    (onItemSelected)="folderSelected($event)"
                                    [textPropertyName]="'name'"
                                    [placeholder]="'queueViewTab.selectFolderPlaceholder' | translate">
            </app-hierarchy-dropdown>
          </div>
          <div *ngIf="isClosedTabActive" class="date-picker-container">
            <label class="filter-label">{{ getLabelByWorkItemType('dateLabel') | translate }}</label>
            <app-date-picker (dateChanged)="onDateChanged($event)" #datePicker></app-date-picker>
          </div>
        </div>

        <div class="filters">
          <button class="toggle-btn filter-button own-filter" *ngIf="shouldDisplayOwnFilter"
                  [ngClass]="{'toggle-btn-active': isOwnFilterActive, 'has-own-items': getOwnItemsCount()}"
                  (click)="onOwnFilterClick()">
            <svg-icon icon="{{ getIconNameForFilter('person', isOwnFilterActive) }}"></svg-icon>
            <div class="own-filter-text" *ngIf="shouldDisplayFilterText">{{ 'queueViewTab.labels.ownItemsLabel' | translate : { count: getOwnItemsCount() } }}</div>
            <div class="own-filter-count" *ngIf="!shouldDisplayFilterText">({{ getOwnItemsCount() }})</div>
            <ng2-tooltip direction="top" text="{{ 'queueViewTab.labels.ownItemsTooltip' | translate }}"></ng2-tooltip>
          </button>
          <button class="toggle-btn filter-button flag-filter" *ngIf="shouldDisplayFlagFilter"
                  [ngClass]="{'toggle-btn-active': isFlagFilterActive, 'has-flagged-items': getFlaggedRowsCount()}"
                  (click)="onFilterFlagsClick()">
            <svg-icon icon="{{ getIconNameForFilter('flag', isFlagFilterActive) }}"></svg-icon>
            <div class="flag-filter-text" *ngIf="shouldDisplayFilterText">{{ 'queueViewTab.labels.chat.flags' | translate : { count: getFlaggedRowsCount() } }}</div>
            <ng-container *ngIf="!shouldDisplayFilterText">
              <div class="flag-filter-count">({{ getFlaggedRowsCount() }})</div>
              <ng2-tooltip direction="top" text="{{ 'queueViewTab.labels.chat.flagsTooltip' | translate }}"></ng2-tooltip>
            </ng-container>
          </button>
          <button class="toggle-btn filter-button warning-filter"
                  [ngClass]="{ 'toggle-btn-active': isWarningFilterActive, 'has-warnings': getWarnedRowsCount() }"
                  (click)="onWarningFilterClick()">
            <svg-icon icon="{{ getIconNameForFilter('alert', isWarningFilterActive) }}"></svg-icon>
            <span class="warning-text" *ngIf="shouldDisplayFilterText">{{ 'queueViewTab.warnings' | translate: { rowsWithDisplayedWarnings: getWarnedRowsCount() } }}</span>
            <ng-container *ngIf="!shouldDisplayFilterText">
              <span class="warning-count">({{ getWarnedRowsCount() }})</span>
              <ng2-tooltip direction="top" text="{{ 'queueViewTab.warningsTooltip' | translate }}"></ng2-tooltip>
            </ng-container>
          </button>
        </div>

        <div class="search-field">
          <mat-form-field floatLabel="never" appearance="outline">
            <svg-icon icon="magnifier" matPrefix></svg-icon>
            <input matInput [(ngModel)]="filterGrid" (ngModelChange)="onModelChange()" placeholder="{{ 'queueViewTab.searchPlaceholder' | translate }}"/>
          </mat-form-field>
        </div>
      </div>
      <div class="grid-options-right">
        <div class="refresh-button" *ngIf="gridSetting.restApiEndpointName && refreshTimestamp" (click)="reloadClosedWorkItems()">
          <svg-icon icon="refresh" [ngClass]="{ 'refresh-icon-spin': isListLoading }"></svg-icon>
          <ng2-tooltip direction="top" text="{{ 'queueViewTab.updateHint' | translate : { refreshTimestamp: refreshTimestamp } }}"></ng2-tooltip>
        </div>
        <button class="download-button" [disabled]="!filteredGridItems || !filteredGridItems.length" (click)="exportWorkItems()">
          <svg-icon icon="download"></svg-icon>
          <ng2-tooltip direction="top" text="{{ 'queueViewTab.exportTooltip' | translate }}"></ng2-tooltip>
        </button>
        <svg-icon *ngIf="hasColumnChooser" icon="gear" class="column-picker-icon" (click)="showColumnPicker()"></svg-icon>
      </div>
    </div>

    <div class="queue-view" [attr.data-automation-id]="'bc-queue-view'">
      <div class="queue-view-tab" *ngIf="!isFilteredGridItemsEmpty() && hasFinishedLoading">
        <div class="queue-view-header-container" [ngStyle]="{'width': columnWidthSum}" [ngClass]="{ 'messaging-header-title': isMessagingSelected }">
          <div class="queue-view-list-header">
            <span *ngIf="areActionsAvailable() && !isMessagingSelected" class="queue-view-list-header-column checkbox-column">
              <mat-checkbox class="queue-view-checkbox" [checked]="allChecked" (change)="checkAllOrNone()" [disableRipple]="true"></mat-checkbox>
            </span>
            <span *ngIf="gridSetting.isFlaggingAvailable" class="queue-view-list-header-column checkbox-column">
              <svg-icon icon="flag-empty"></svg-icon>
            </span>
            <ng-container *ngFor="let column of gridSetting.columnConfig">
            <span (click)="sortByColumns(column)" class="queue-view-list-header-column"
                  *ngIf="!isColumnHidden(column)"
                  [ngStyle]="{'flex-basis': column.baseWidth}"
                  [ngClass]="{'selected': column.valueProperty === getColumnSortingSettings()?.valueProperty, 'warning-column': isAnyWarningInColumn(column) }">{{column.displayName | translate}}
              <svg-icon class="sort-direction"
                        [ngClass]="{'rotated': isColumnSortingAscending()}"
                        icon="sorting"></svg-icon>
            </span>
            </ng-container>
          </div>
        </div>

        <cdk-virtual-scroll-viewport itemSize="51"
                                     [ngStyle]="{'width': columnWidthSumWrapper}"
                                     class="queue-view-list-container">
          <div class="queue-view-list-item"
               [ngStyle]="{'width': columnWidthSum}"
               [ngClass]="{'selected': (selectedPreviewItem?.ItemID === row?.ItemID), 'checked': row.checked, 'warning': isAnyWarningInRow(row)}"
               *cdkVirtualFor="let row of filteredGridItems"
               (click)="openPreview(row)"
               [attr.data-automation-id]="'bc-queue-view-list-item'">
            <span *ngIf="areActionsAvailable()" class="queue-view-list-item-column checkbox-column">
              <mat-checkbox class="queue-view-checkbox" [checked]="row.checked"
                            (click)="$event.stopPropagation()" (change)="changeChecked(row)" [disableRipple]="true" *ngIf="!isSelectionHidden(row)"></mat-checkbox>
            </span>
            <span *ngIf="gridSetting.isFlaggingAvailable" class="queue-view-list-header-column checkbox-column">
              <app-flag [workItemId]="row.ChatID" [workItemFlagState]="row.Flagged"></app-flag>
            </span>
            <ng-container *ngFor="let column of gridSetting.columnConfig">
              <span class="queue-view-list-item-column"
                    *ngIf="!isColumnHidden(column)"
                    title="{{ getValue(row, column) }}"
                    [ngStyle]="{'flex-basis': column.baseWidth}"
                    [ngClass]="{'warning': hasColumnWarning(row, column)}">{{getValue(row, column)}}</span>
            </ng-container>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>

      <div class="empty-state" *ngIf="hasFinishedLoading && isFilteredGridItemsEmpty()">
        <svg-icon icon="no-items"></svg-icon>
        <div class="no-items-title">{{ 'queueViewTab.emptyState.noItemsTitle'| translate}}</div>
        <div class="no-items-subtitle">{{ 'queueViewTab.emptyState.noItemsSubtitle'| translate}}</div>
      </div>

      <app-loading *ngIf="!hasFinishedLoading"></app-loading>
    </div>

    <div class="queue-view-panel-footer-buttons" *ngIf="areActionsAvailable()">
      <ng-container *ngIf="!transferPanelOpened">
        <button class="btn btn-light button-assign-to"
                *ngIf="hasAssignPermission && !isEmailClosedTabActive"
                [disabled]="!anyChecked"
                (click)="onAssignToClicked()">
          <span>{{ "queueViewTab.buttons.assignTo" | translate }}</span>
        </button>
        <button class="btn btn-light button-assign-self"
                *ngIf="hasAssignPermission && !isEmailClosedTabActive"
                [disabled]="!anyChecked"
                (click)="onAssignToMeClicked()">
          <span>{{ "queueViewTab.buttons.assignSelf" | translate }}</span>
        </button>
        <button class="btn btn-light button-close-items"
                *ngIf="hasClosePermission && !isChatBotTabActive && !isEmailClosedTabActive"
                [disabled]="!anyChecked"
                (click)="onCloseClicked()">
          <span>{{ "queueViewTab.buttons.close" | translate }}</span>
        </button>
        <button class="btn btn-light button-reopen-thread"
                *ngIf="isEmailClosedTabActive"
                [disabled]="!anyChecked"
                (click)="onReopenThreadsClicked()">
          <span>{{ "queueViewTab.buttons.reopen" | translate }}</span>
        </button>
      </ng-container>
    </div>
  </div>
  <div class="work-item-preview-container" *ngIf="selectedPreviewItem">
    <app-work-item-preview [workItemId]="selectedPreviewItem.ItemID" [isClosed]="!!selectedPreviewItem.Closed" [workItemType]="selectedPreviewItemType" [tabName]="tabName" (closeAction)="closePreview()"></app-work-item-preview>
  </div>
</div>

<div class="transfer-panel-container" *ngIf="transferPanelOpened">
  <div class="transfer-panel-modal-background" (click)="closeTransferPanel()"></div>
  <app-transfer-panel (backButtonAction)="closeTransferPanel()" (successfulTransferAction)="successfulTransfer()" [escalateChat]="shouldEscalateChat"
                      [workItemType]="availabilityWorkItemType" [workItemIds]="getSelectedItemIds()"></app-transfer-panel>
</div>

<app-column-picker *ngIf="columnPickerVisible"
                   [columnSettings]="gridSetting.columnSettings"
                   [columnsWithTimeCondition]="defaultColumnsWithTimeConditions"
                   (saveChanges)="columnSettingsUpdated($event)"></app-column-picker>
